export default __webpack_public_path__ + "static/teen-group-5d58b576b3741a9c559b3b7c99de58a3.png";